export default __webpack_public_path__ + "static/media/ic-next-prev.83114e48.svg";